import { useEffect, useState } from "react"
import useWindowSize from "./useWindowSize"

const useIsMobile = () => {
  const windowSize = useWindowSize()
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    if (windowSize.width == undefined) return

    if (windowSize?.width < 640) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  }, [windowSize])

  return isMobile
}

export default useIsMobile
